export default "__VITE_PUBLIC_ASSET__6ee5c06d__"